import { Box, Textarea } from "@mantine/core";
import { useAtom } from "jotai";

import Button from "components/Button";
import Flex from "components/Flex";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { additionalDetailsAtom } from "atoms/additionalDetails";
import { useClientTranslation } from "hooks/useClientTranslation";
import { useDigitalJourneyPageRouting } from "hooks/useDigitalJourneyPageRouting";
import { useEventTracking } from "hooks/useEventTracking";

export const DJAdditionalInformationPage = () => {
  const { t } = useClientTranslation();
  const { trackEvent } = useEventTracking();
  const { onNext, continueCTA } = useDigitalJourneyPageRouting();
  const [additionalDetails, setAdditionalDetails] = useAtom(additionalDetailsAtom);

  const onContinue = () => {
    trackEvent({ name: "Digital Journey Additional Information - continue" });
    onNext();
  };

  return (
    <PageLayout contentSpacing="space-between">
      <Flex px={24} py={24} gap={16} flex={1} mb={16}>
        <Text as="h1" sizeVariant="xl" weight={600}>
          Ulteriori dettagli
        </Text>
        <Box mt={16}>
          <Text weight={600}>Inserisci le eventuali ulteriori informazioni sul sinistro che ci vuoi comunicare.</Text>
          <Text>(massimo 500 caratteri)</Text>
        </Box>
        <Textarea
          placeholder="Inserisci..."
          value={additionalDetails}
          onChange={(e) => setAdditionalDetails(e.currentTarget.value)}
          maxLength={500}
          autosize
          maxRows={4}
          minRows={3}
        />
      </Flex>
      <Flex px={24} py={24} gap={16}>
        <Button onClick={onContinue}>{continueCTA}</Button>
      </Flex>
    </PageLayout>
  );
};
